import React from "react";
import { useTranslation } from "react-i18next";
import { Form, Modal } from "reactstrap";
import { ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import { useFormik } from "formik";
import BtnCustom from "components/common/btn-custom";
import { successToaster } from "components/common/toast";
import CustomPaginatedSelect from "components/common/CustomPaginatedSelect";
import { AssignProductsSubCategory } from "network/productAPI";
import { AssignSubCategorySchema } from "components/schema/AssignSubCategorySchema";
import { GetSectionSubCategoriesAPI } from "network/categoryAPI";
import { GetSectionCategoriesAPI } from "network/categoryAPI";
const pageSize = 10;
const AssignCategoryModal = ({
  open,
  setOpen,
  selectedRowIds,
  sectionId,
  setFetchTrigger,
  setSelectedRowIds,
}) => {
  const { t } = useTranslation("common");
  const loadCategoryOptions = async (
    search,
    prevOptions = [],
    additional = { page: 1 }
  ) => {
    const page = additional.page || 1;
    try {
      const response = await GetSectionCategoriesAPI(
        sectionId,
        page,
        pageSize,
        search
      );

      if (response.success) {
        const newOptions = response.data.categories.map((category) => ({
          value: category.uuid,
          label: category.name,
        }));

        return {
          options: [...newOptions],
          hasMore: response.data?.has_next,
          additional: { page: page + 1 },
        };
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }

    return {
      options: prevOptions,
      hasMore: false,
      additional: { page: page + 1 },
    };
  };
  const loadSubCategoryOptions = async (
    search,
    prevOptions = [],
    additional = { page: 1 }
  ) => {
    const page = additional.page || 1;

    try {
      const response = await GetSectionSubCategoriesAPI(
        sectionId,
        page,
        pageSize,
        search
      );

      if (response.success) {
        const newOptions = response?.data?.sub_categories?.map((category) => ({
          value: category.uuid,
          label: category?.name,
        }));

        return {
          options: [...newOptions],
          hasMore: response?.data?.has_next,
          additional: { page: page + 1 },
        };
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }

    return {
      options: prevOptions,
      hasMore: false,
      additional: { page: page + 1 },
    };
  };

  const {
    errors,
    values,
    handleSubmit,
    touched,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    resetForm,
  } = useFormik({
    initialValues: {
      subCategories: "",
      categories: "",
    },
    enableReinitialize: true,
    validationSchema: AssignSubCategorySchema,
    onSubmit: async (values) => {
      const Payload = {
        products: selectedRowIds,
        sub_categories: [values?.subCategories?.value],
        categories: [values?.categories?.value],
      };
      try {
        const response = await AssignProductsSubCategory(sectionId, Payload);
        if (response.success) {
          successToaster(response.message);
          setSelectedRowIds([]);
          setFetchTrigger((prev) => !prev);
          resetForm();
          setOpen(false);
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  const handleCloseModel = () => {
    resetForm();
    setOpen(false);
  };
  return (
    <div>
      <Modal isOpen={open} toggle={handleCloseModel} className="modal-lg">
        <div className="modal-header">
          <h5 className="modal-title text-capitalize" id="exampleModalLabel">
            {t("assignModal.title")}
          </h5>
          <button
            aria-label={t("actions.close")}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCloseModel}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleSubmit}>
            <CustomPaginatedSelect
              label={t("assignModal.selectCategory")}
              name="categories"
              placeholder={t("assignModal.selectCategory")}
              loadOptions={loadCategoryOptions}
              value={values.categories}
              onChange={(value) => setFieldValue("categories", value)}
              onBlur={() => setFieldTouched("categories", true)}
              touched={touched}
              errors={errors}
              colorCode="#222a42"
            />
            <CustomPaginatedSelect
              label={t("assignModal.selectSubCategory")}
              name="subCategories"
              placeholder={t("assignModal.selectSubCategory")}
              loadOptions={loadSubCategoryOptions}
              value={values.subCategories}
              onChange={(value) => setFieldValue("subCategories", value)}
              onBlur={() => setFieldTouched("subCategories", true)}
              touched={touched}
              errors={errors}
              colorCode="#222a42"
            />

            <BtnCustom
              className="btn-round mt-3"
              color="primary"
              size="lg"
              type="submit"
              isLoading={isSubmitting}
              submittingText={t("assignModal.assigning")}
            >
              {t("assignModal.assign")}
            </BtnCustom>
          </Form>
        </div>
      </Modal>
    </div>
  );
};
export default AssignCategoryModal;
